module.exports = __webpack_public_path__ + "static/media/Icon awesome-user-alt.355dd3bb.svg";